var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['w-full', 'flex flex-col', 'bg-light-ui-100 dark:bg-dark-ui-100']},[_c(_setup.LandsideHeader,{attrs:{"data-testid":"landsideHeader"}}),_vm._v(" "),_c(_setup.LandsideMain),_vm._v(" "),_c(_setup.LandsideFooter)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }